module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/has-binary/~/isarray/index.js
// module id = ../../../../has-binary/node_modules/isarray/index.js
// module chunks = 4